const LoadingComponent = () => {
  return (
      <div className="d-flex justify-content-center align-items-center h-100 w-100 gap-2">
          
      <div className="spinner-grow delay-1" role="status"></div>
      <div className="spinner-grow delay-2" role="status"></div>
      <div className="spinner-grow delay-3" role="status"></div>
    </div>
  );
};
export default LoadingComponent;
